import { render, staticRenderFns } from "./taskselect.vue?vue&type=template&id=6474f346&scoped=true&"
import script from "./taskselect.vue?vue&type=script&lang=js&"
export * from "./taskselect.vue?vue&type=script&lang=js&"
import style0 from "./taskselect.vue?vue&type=style&index=0&id=6474f346&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474f346",
  null
  
)

export default component.exports